import * as React from 'react';
import icon from '../../assets/img/flags/oregon.svg';

export const Oregon = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
